import { useState } from "react";
import { deleteSectionsToDocumentsURL } from "../utils/ConstantsURL";
import { toastAlert } from "../utils/AlertContext";

export const useDeleteSection = (token) => {
  const [loading, setLoading] = useState(false);

  const deleteSection = async (sectionId, userId = 0) => {
    setLoading(true);
    try {
      const response = await fetch(deleteSectionsToDocumentsURL(), {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          section_id: sectionId,
          user_id: userId,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Error al eliminar la sección");
      }

      toastAlert("Sección eliminada correctamente", "success");
      return true;
    } catch (error) {
      console.error("Error al eliminar la sección:", error);
      toastAlert("Error al eliminar la sección: " + error.message, "error");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { deleteSection, loading };
};
